import ControlledTable from "Components/ControlledTable";
import { FormDataType } from "DataTypes/Form";
import { actionArrType, columnType } from "DataTypes/Table";

const CMInputBox: FormDataType = {
  id: "caremanager",
  placeholder: "Enter Care Manager",
  boxType: "input-box",
  validatetype: "any",
  readOnly: true
};

const CMArrBox: FormDataType = {
  id: "caremanagerId",
  placeholder: "Select Care Manager",
  boxType: "single-select-drop",
  validatetype: "dropdown",
};

const CPBPInputBox: FormDataType = {
  ///CBP stands for Care Plan Billable Provider as known as Billable Provider
  id: "billableProvider",
  placeholder: "Enter Provider Name",
  boxType: "input-box",
  validatetype: "any",
  readOnly: true
};

const CPBPArrBox: FormDataType = {
  id: "billableProviderId",
  boxType: "single-select-drop",
  validatetype: "dropdown",
};

const TPInputBox: FormDataType = { ///TP stands for Team Provider
  id: "teamProvider",
  placeholder: "Enter Rendering Provider Name",
  boxType: "input-box",
  validatetype: "any",
  readOnly: true
};

const TPArrBox: FormDataType = {
  id: "teamProviderId",
  placeholder: "Select Rendering Provider",
  boxType: "single-select-drop",
  validatetype: "dropdown",
};

const SPInputBox: FormDataType = { ///SP stands for Supervising Provider
  id: "supervisionProvider",
  placeholder: "Enter Supervising Provider",
  boxType: "input-box",
  validatetype: "any",
  readOnly: true
};

const SPArrBox: FormDataType = {
  id: "supervisionProviderId",
  placeholder: "Select Supervising Provider",
  boxType: "single-select-drop",
  validatetype: "dropdown",
};
/// only for client, not confirmed
const PCCInputBox: FormDataType = { ///SP stands for Supervising Provider
  id: "primaryCareCoordinator",
  placeholder: "Enter Primary Care Coordinator",
  boxType: "input-box",
  validatetype: "any",
  readOnly: true
};
const PCCArrBox: FormDataType = {
  id: "primaryCareCoordinatorId",
  placeholder: "Select Primary Care Coordinator",
  boxType: "single-select-drop",
  validatetype: "dropdown",
};

const CCArrBox: FormDataType = {
  id: "careplanCoordinators",
  placeholder: "Select Secondary Care Coordinator",
  boxType: "multi-select-drop",
  validatetype: "dropdown",
  dropListHeight: "400px",
};

interface CTFormDataProps {
  form1ReadOnly: boolean;
  CPInitiatedByCM: boolean;
  CPInitiatedByProvider: boolean;
  showCPBP: boolean;
  showLabelCP: boolean;
  showCoordinators: boolean;
}

const FormArr1: (props: CTFormDataProps) => FormDataType[] = (props) => {
  const {
    form1ReadOnly,
    CPInitiatedByCM,
    CPInitiatedByProvider,
    showCPBP,
    showLabelCP,
    showCoordinators
  } = props;
  return [
    {
      label: "Care Manager",
      boxSize: 3,
      required: true,
      ...form1ReadOnly ?
        CMInputBox :
        { ...CMArrBox, readOnly: CPInitiatedByCM }
    },
    ...showCPBP ? [
      {
        label: (showLabelCP ? "Care Plan" : "Treatment Plan") +
          " Rendering Provider",
        placeholder: "Select " +
          (showLabelCP ? "Care Plan" : "Treatment Plan") +
          " Rendering Provider",
        boxSize: 3,
        required: true,
        ...form1ReadOnly ?
          CPBPInputBox :
          { ...CPBPArrBox, readOnly: CPInitiatedByProvider }
      }
    ] as FormDataType[] : [],
    {
      label: "Rendering Provider",
      boxSize: 3,
      required: true,
      ...form1ReadOnly ? TPInputBox : TPArrBox
    },
    {
      label: "Supervising Provider",
      boxSize: 3,
      required: true,
      ...form1ReadOnly ? SPInputBox : SPArrBox
    },
    ...showCoordinators ? [
      {
        label: "Primary Care Coordinator",
        boxSize: 3,
        required: true,
        ...form1ReadOnly ? PCCInputBox : PCCArrBox,
      },
      ...form1ReadOnly ?
        [] : [{
          label: "Secondary Care Coordinators",
          boxSize: 3,
          ...CCArrBox,
          readOnly: form1ReadOnly,
          maxLength: 7
        }],
    ] as FormDataType[] : [],
    {
      id: "authorizedRepresentative1",
      label: "Authorized Representative 1",
      placeholder: "Enter Authorized Representative",
      boxType: "input-box",
      boxSize: 3,
      validatetype: "authRepresent",
      required: false,
      enableFormLoad: true,
      readOnly: form1ReadOnly
    },
    {
      id: "authorizedRepresentative2",
      label: "Authorized Representative 2",
      placeholder: "Enter Authorized Representative",
      boxType: "input-box",
      boxSize: 3,
      validatetype: "authRepresent",
      required: false,
      enableFormLoad: true,
      readOnly: form1ReadOnly
    },
    {
      id: "authorizedRepresentative3",
      label: "Patient Representative",
      placeholder: "Enter Patient Representative",
      boxType: "input-box",
      boxSize: 3,
      validatetype: "authRepresent",
      required: false,
      enableFormLoad: true,
      readOnly: form1ReadOnly
    },
  ]
};

const FormArr2: FormDataType[] = [
  {
    id: "additionalProviderName",
    label: "Additional Provider",
    placeholder: "Enter Provider Name",
    boxType: "input-box",
    boxSize: 3,
    validatetype: "alphanumericPeriod",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "additionalProviderSpeciality",
    label: "Additional Provider's Speciality",
    placeholder: "Enter Provider Speciality",
    boxType: "input-box",
    boxSize: 3,
    validatetype: "alphanumericName",
    enableFormLoad: true,
  },
  {
    id: "addProviderOrganization",
    label: "Organization Name",
    placeholder: "Enter Organization Name",
    boxType: "input-box",
    boxSize: 3,
    validatetype: "org-name",
    enableFormLoad: true,
  },
  {
    id: "phoneNumber",
    label: "Phone Number",
    placeholder: "Enter Phone Number",
    boxType: "input-box",
    boxSize: 3,
    validatetype: "mobile no.",
    enableFormLoad: true,
  },
  {
    id: "faxNumber",
    label: "Fax Number",
    placeholder: "Enter Fax Number",
    boxType: "input-box",
    boxSize: 3,
    validatetype: "fax-number",
    enableFormLoad: true,
  },
];

const CCTableCol: columnType[] = [
  {
    id: "careCoordinator",
    label: "Selected Secondary Care Coordinators",
    width: "100%",
    align: "left",
    colType: "text",
    rowType: "boldText",
  },
];

const TblActionArr: (handleDelete: () => void) => actionArrType[] = (
  handleDelete
) => {
  const Arr: actionArrType[] = [
    ControlledTable.ActionData.deleteAction(handleDelete),
  ];
  return Arr;
};

export { FormArr1, FormArr2, CCTableCol, TblActionArr }
